import '../../scss/modules/_map.scss'


import GoogleMaps from './GoogleMaps/GoogleMaps'

const map = document.querySelector('.map__container')
if (map) {
  const Map  = new GoogleMaps(map)
  Map.initMap()
}
